export const togglePlan = (selector) => {
  const togglePlanBtn = document.querySelector('.membership-page__toggle-wrapper');

  togglePlanBtn.addEventListener('click', () => selector.classList.toggle('yearly'));
};
